import FJActionConstant from "../../constant/FJActionConstant";
import FJCoreConstant from "../../core/constant/FJCoreConstant";

let FJDocumentColor = (function () {
  return {
    /**
     * @description 设置添加到document的颜色
     * @param data
     * @returns {{data: *, type: string}}
     */
    setDocumentColorsAction: function (data) {
      return {
        type: FJActionConstant.DOCUMENT_COLOR_CHANGED,
        data,
      }
    },

    /**
     * @description 添加颜色
     * @param type
     * @param color
     * @returns {Function}
     */
    addDocumentColorAction: function (type, color) {
      return (dispatch, getState) => {
        const state = getState().documentColor;
        let isSolid = type === FJCoreConstant.SOLID_COLOR;
        let colors = isSolid ?
          state.documentColors.solidColors.slice(0) : state.documentColors.doubleColors.slice(0);
        let index = colors.findIndex((colorItem) => {
          return isSolid ? colorItem === color :
            (colorItem[0] === color.mainColor && colorItem[1] === color.subColor);
        });
        if (index !== -1) {
          colors.splice(index, 1);
        }

        let useColor = isSolid ? color : [color.mainColor, color.subColor];
        colors.unshift(useColor);
        let newDocumentColors = {};
        if (isSolid) {
          newDocumentColors.solidColors = colors;
          newDocumentColors.doubleColors = state.documentColors.doubleColors;
        } else {
          newDocumentColors.solidColors = state.documentColors.solidColors;
          newDocumentColors.doubleColors = colors;
        }
        dispatch(this.setDocumentColorsAction(newDocumentColors));
      }
    },

    /**
     * @description 删除颜色
     * @param type
     * @param index
     * @returns {Function}
     */
    deleteDocumentColorAction: function (type, index) {
      return (dispatch, getState) => {
        const state = getState().documentColor;
        let colors = type === FJCoreConstant.SOLID_COLOR ?
          state.documentColors.solidColors.slice(0) : state.documentColors.doubleColors.slice(0);
        colors.splice(index, 1);
        let newDocumentColors = {};
        if (type === FJCoreConstant.SOLID_COLOR) {
          newDocumentColors.solidColors = colors;
          newDocumentColors.doubleColors = state.documentColors.doubleColors;
        } else {
          newDocumentColors.solidColors = state.documentColors.solidColors;
          newDocumentColors.doubleColors = colors;
        }
        dispatch(this.setDocumentColorsAction(newDocumentColors))
      }
    },
  }
})();

export default FJDocumentColor;